import { useState, useEffect } from 'react';
import tinycolor from 'tinycolor2';

const useColorContrast = (color: string) => {
  const [isLight, setIsLight] = useState(false);

  useEffect(() => {
    const calculateContrast = (inputColor: string) => {
      const parsedColor = tinycolor(inputColor);
      setIsLight(parsedColor.isLight());
    };

    calculateContrast(color);
  }, [color]);

  return isLight;
};

export default useColorContrast;
